// --------------------------------------------------------------
// Created On: 2025-10-29
// Author: Zachary Thomas
//
// Last Modified: 2025-11-02
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import deepCopy from "src/utilities/deepCopy";

const initialState: AlertMessage[] = [];

// A Redux slice for managing alert notifications.
const alertsSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    setAlerts: (state, action: PayloadAction<AlertMessage[]>) => action.payload,
    toggleAlert: (state, action: PayloadAction<number>) => {
      const payload = action.payload;
      const alertsDeepCopy = deepCopy(state);
      const targetAlert = alertsDeepCopy.find((alert) => alert.alertMessageId === payload);
      if (targetAlert !== undefined) {
        targetAlert.unread = !targetAlert.unread;
      }
      return alertsDeepCopy;
    },
    toggleAllAlerts: (state) => {
      const alertsDeepCopy = deepCopy(state);
      let allRead = true;
      alertsDeepCopy.forEach((alert) => {
        if (alert.unread) {
          allRead = false;
        }
      });
      alertsDeepCopy.forEach((alert) => (alert.unread = allRead));
      return alertsDeepCopy;
    },
    deleteAlert: (state, action: PayloadAction<number>) => {
      const payload = action.payload;
      const alertsDeepCopy = deepCopy(state);
      const alertMessageIndex = alertsDeepCopy.findIndex((alert) => alert.alertMessageId === payload);
      if (alertMessageIndex !== -1) {
        alertsDeepCopy.splice(alertMessageIndex, 1);
      }
      return alertsDeepCopy;
    },
    deleteAllAlerts: () => [],
  },
});

export const { setAlerts, toggleAlert, toggleAllAlerts, deleteAlert, deleteAllAlerts } = alertsSlice.actions;
export default alertsSlice.reducer;

interface AlertMessage {
  alertMessageId: number;
  alertCode: string;
  date: string;
  message: string;
  unread: boolean;
  urgency: string;
  alertUrl: string;
}
